import { render, staticRenderFns } from "./ArtistPod.vue?vue&type=template&id=783d9184&scoped=true&"
import script from "./ArtistPod.vue?vue&type=script&lang=js&"
export * from "./ArtistPod.vue?vue&type=script&lang=js&"
import style0 from "./ArtistPod.vue?vue&type=style&index=0&id=783d9184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d9184",
  null
  
)

export default component.exports